import React from 'react';
import {
  IonButton,
  IonCheckbox,
  IonInput,
  IonInputPasswordToggle,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';
import './UnregisterForm.css';

type UnregisterFormProps = {
  isValid: boolean;
  proceed: () => void;
  confirm: boolean;
  setConfirm: (b: boolean) => void;
};

export default function UnregisterForm({
  isValid,
  proceed,
  confirm,
  setConfirm,
}: UnregisterFormProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="instructions">{t('unregister.subtitle')}</p>
      <p className="pt-2 instructions">{t('unregister.info')}</p>
      <p className="pt-2 instructions">{t('unregister.info2')}</p>

      <div className="pt-4 unregister-confirm">
        <div>
          <IonCheckbox
            value={confirm}
            onIonChange={(e) => setConfirm(e.detail.checked)}
          ></IonCheckbox>
        </div>
        <div>
          <span>{t('unregister.confirm1')}</span>
          <a
            href={t('unregister.confirmurl')!}
            rel={'noreferrer'}
            target={'_blank'}
          >
            {t('unregister.confirm2')}
          </a>
          <span>{t('unregister.confirm3')}</span>
        </div>
      </div>

      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('unregister.submit')}
        </IonButton>
      </div>
    </>
  );
}
